module.exports = __webpack_public_path__ + "static/scale-model-of-better-homes-and-gardens-test-garden-in-des-moines-iowa-373a872e388fdf8eae5d683598b62abf.png";